export const getIngredientAllergenString = (
  allergens: string[] = [],
  possibleAllergens: string[] = []
) => {
  if (!!allergens.length && !!possibleAllergens.length) {
    return ` (${allergens.join(', ')}. May contain ${possibleAllergens.join(
      ', '
    )})`
  }
  if (allergens.length) {
    return ` (${allergens.join(', ')})`
  }
  if (possibleAllergens.length) {
    return ` (May contain ${possibleAllergens.join(', ')})`
  }
  return null
}
